import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { IconMenu2, IconX } from '@tabler/icons-react';
import ThemeToggle from './ThemeToggle';
import './Navigation.css';

const Navigation: React.FC = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const scrollToSection = (sectionId: string) => {
    // If we're not on the home page, navigate to home first
    if (location.pathname !== '/') {
      navigate(`/#${sectionId}`);
      return;
    }
    
    const element = document.getElementById(sectionId);
    if (element) {
      // Get the navigation height - we only need to offset by this to show the section title
      const navHeight = document.querySelector('.navigation')?.getBoundingClientRect().height || 0;
      
      const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = elementPosition - navHeight;
      
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
    setIsMobileMenuOpen(false); // Close mobile menu after navigation
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <nav className="navigation">
      <div className="nav-container">
        <div className="nav-brand">
          <button 
            onClick={() => scrollToSection('hero')} 
            className="nav-link nav-button brand-button"
          >
            Zi Wang
          </button>
          <ThemeToggle />
        </div>
        
        {/* Desktop Navigation - Center */}
        <div className="nav-links desktop-nav">
          <button 
            onClick={() => scrollToSection('current-work')} 
            className="nav-link nav-button"
          >
            Product Design
          </button>
          <span className="nav-separator">·</span>
          <button 
            onClick={() => scrollToSection('my-process')} 
            className="nav-link nav-button"
          >
            My Approach
          </button>
          <span className="nav-separator">·</span>
          <button 
            onClick={() => scrollToSection('pre-product-design')} 
            className="nav-link nav-button"
          >
            Outside of Work
          </button>
        </div>

        {/* Right Side Links */}
        <div className="nav-right desktop-nav">
          <a 
            href="https://www.linkedin.com/in/ziwang31" 
            target="_blank" 
            rel="noopener noreferrer"
            className="nav-link"
          >
            LinkedIn
          </a>
          <span className="nav-separator">·</span>
          <button 
            onClick={() => scrollToSection('contact')} 
            className="nav-link nav-button"
          >
            Contact Me
          </button>
        </div>

        {/* Mobile Hamburger Button */}
        <button 
          className="mobile-menu-toggle"
          onClick={toggleMobileMenu}
          aria-label="Toggle mobile menu"
        >
          {isMobileMenuOpen ? (
            <IconX size={20} className="mobile-menu-icon" />
          ) : (
            <IconMenu2 size={20} className="mobile-menu-icon" />
          )}
        </button>
      </div>

      {/* Mobile Navigation Menu */}
      <div className={`mobile-nav ${isMobileMenuOpen ? 'open' : ''}`}>
        <button 
          onClick={() => scrollToSection('current-work')} 
          className="mobile-nav-link"
        >
          Product Design
        </button>
        <button 
          onClick={() => scrollToSection('my-process')} 
          className="mobile-nav-link"
        >
          My Approach
        </button>
        <button 
          onClick={() => scrollToSection('pre-product-design')} 
          className="mobile-nav-link"
        >
          Besides Work
        </button>
        <a 
          href="https://www.linkedin.com/in/ziwang31" 
          target="_blank" 
          rel="noopener noreferrer"
          className="mobile-nav-link"
          onClick={() => setIsMobileMenuOpen(false)}
        >
          LinkedIn
        </a>
        <button 
          onClick={() => scrollToSection('contact')} 
          className="mobile-nav-link"
        >
          Contact Me
        </button>
      </div>
    </nav>
  );
};

export default Navigation; 